export const version = '4.1.24' as const
